<template>
    <div class="page-head">
        <div class="head-title">Carrot TTS</div>
    </div>
    <div class="page-body">
        <div class="tts-input">
            <ReumTextBox class="input-txt" label="Text to Speech" v-model="comp.text" @keypress.enter="comp.doMakeTTS()"></ReumTextBox>
            <button class="input-btn" @click="comp.doMakeTTS">Speak</button>
        </div>
        <audio id="pop-audioplayer" class="rr-voice" :class="{ 'hidden':comp.play.vpath=='' }" controls :src="comp.play.vpath" @ended="comp.gotEnded"></audio>
    </div>
    <div class="lds-loader" :class="{ 'active':comp.loader==true }">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import axios from "axios";

import ReumTextBox from "@/components/ReumLib/UI/ReumTextBox.vue";

export default {
    name: "tts",
    components: {
        ReumTextBox,
    },

    setup() {

        const comp = reactive({
            text : "",
            audioplayer2: null,
            loader: false,
            play: { idx: 0, vpath: "", status: 0 },
            doMakeTTS: () => {
                comp.loader = true
                let params = { txt: comp.text }
                let vh = "http://dev.lxl.kr:40088"
                axios.get(vh + "/tts/make", { params: params }).then((res) => {
                    if (res.data.err == 0) {
                        comp.play.vpath = vh + res.data.wav
                    }
                    comp.loader = false
                })
            },
            onPlay:() => {
                setTimeout(() =>{
                    comp.play.status = 1
                    comp.audioplayer2.play();
                }, 200)
            },
            gotEnded:() => {
                console.log('play done')
                comp.play.idx = 0
                comp.play.status = 0
            },
            
        })

        onMounted(() => {
            comp.audioplayer2 = document.getElementById("pop-audioplayer")
        })

        return { comp };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";
    .page-head {
        position:fixed; top:0; left:0; width:100%; height:50px; z-index:910; background-color:transparent; border-bottom: 1px solid #ececec;
        .head-title {
            display:inline-block; font-size:22px; line-height:48px;
        }
    }
    .page-body {
        position:fixed; top:50px; left:0; width:100%; height:calc(100% - 50px); background-color:#fff;

        .tts-input {
            .input-txt {
                display:inline-block; width:calc(100% - 100px)
            }
            .input-btn {
                display:inline-block; width:100px; height:39px;
                border: 1px solid #C0C0C0; background-color: #eaeaea; color: #3a3a3a; border-radius: 20px;
            }
        }

        .rr-voice {
            &.hidden {
                display:none;
            }
        }
    }

    .lds-loader {
        position:fixed; top:0; left:0; width:100%; height:100%; background-color:rgba(0,0,0,0.1); z-index:9999; display:none;
        &.active {
            display:block;
        }
        .lds-ring {
            position: absolute; top:0; left:0; right:0; bottom:0; margin:auto;
            display: inline-block;
            width: 80px;
            height: 80px;
            div {
                box-sizing: border-box;
                display: block;
                position: absolute;
                width: 64px;
                height: 64px;
                margin: 8px;
                border: 8px solid #fff;
                border-radius: 50%;
                animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
                border-color: #fff transparent transparent transparent;
                &:nth-child(1) {
                    animation-delay: -0.45s;
                }
                &:nth-child(2) {
                    animation-delay: -0.3s;
                }
                &:nth-child(3) {
                    animation-delay: -0.15s;
                }
            }
        }
        @keyframes lds-ring {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }

</style>
